/** Replacement for IonTitle, because it doesn't allow styling of non-part shadow dom elements */

import { styled } from "@mui/material"

export const Title = styled("div")({
  "html.md &": {
    paddingInline: "20px",
    fontSize: "1.25rem",
    fontWeight: 500,
    letterSpacing: "0.0125em",
  },
  "html.ios &": {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: 0,
    fontSize: "min(1.0625rem, 20.4px)",
    fontWeight: 600,
    insetInlineStart: 0,
    paddingInline: "90px",
    paddingBottom: "3px",
    paddingTop: "3px",
    textAlign: "center",
    width: "100%",
    height: "100%",
  },
})
